(function(app) {

    app.provider("transactionRelationshipApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    //GETs
                    service.get = function(transactionId, transactionRelationshipId) {
                        return complianceHubApiGateway.get("/Transactions/" +
                            transactionId +
                            "/TransactionRelationships/" +
                            transactionRelationshipId);
                    };

                    service.getTransactionRelationships = function(transactionId) {
                        return complianceHubApiGateway.getArray("/Transactions/" + transactionId + "/TransactionRelationships");
                    };

                    //PUTs
                    service.update = function(transactionId, transactionRelationshipId, transactionRelationship) {
                        return complianceHubApiGateway.put("/Transactions/" +
                            transactionId +
                            "/TransactionRelationships/" +
                            transactionRelationshipId,
                            transactionRelationship);
                    };

                    //POSTs
                    service.add = function(transactionId, transactionRelationship) {
                        return complianceHubApiGateway
                            .post("/Transactions/" + transactionId + "/TransactionRelationships",
                                transactionRelationship);
                    };

                    //DELETEs
                    service.delete = function(transactionId, transactionRelationshipId) {
                        return complianceHubApiGateway
                            .delete("/Transactions/" +
                                transactionId +
                                "/TransactionRelationships/" +
                                transactionRelationshipId);
                    }

                    return service;

                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line